import React from 'react'
import Box from '@mui/material/Box'

import { PROFILE_SECURITY_STATUS_CHIP_SX } from '../constants/profileSecurityConstants'

export default function ProfileSecurityStatusChip({ label, tone = 'available' }) {
  return (
    <Box component="span" sx={PROFILE_SECURITY_STATUS_CHIP_SX[tone] || PROFILE_SECURITY_STATUS_CHIP_SX.available}>
      {label}
    </Box>
  )
}
